<template>
  <div class="form-certification">
    <h2>
      EPC Projects
    </h2>
    <project-base
      :data="data"
      :staff-id="staffId"
      :audit-data="auditData"
      :disabled="disabled"
      :current-tab="currentTab"
    />
    <h2>
      PMC&PDC Projects
    </h2>
    <project-developer
      :data="data"
      :staff-id="staffId"
      :audit-data="auditData"
      :disabled="disabled"
      :current-tab="currentTab"
    />
  </div>
</template>

<script>
import ProjectDeveloper from './projectDeveloper.vue';
import ProjectBase from './projectBase.vue';

export default {
  components: {
    ProjectDeveloper,
    ProjectBase,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    staffId: {
      type: String,
      default: '',
    },
    auditData: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    currentTab: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
    }
  },
  computed: {
  },
  watch: {
  },
  mounted() {
  },
  methods: {
  },
}
</script>
<style lang="scss">
.form-certification{
  &-top{
    text-align: right;
  }
  .table-td{
    text-align: center;
    line-height: 50px;
    &-sm{
      width: 200px;
    }
  }
}
</style>
